(() => {
  'use strict';
  const resetQuantity = (target) => {
    const form = target.closest('form.product-form');
    if (!form) return;
    const input = form.querySelector('input[name="quantity"]');
    if (!input || input.value === '1') return;
    input.value = '1';
    input.dispatchEvent(new Event('input', { bubbles: true }));
    input.dispatchEvent(new Event('change', { bubbles: true }));
  };
  document.addEventListener('change', (event) => {
    if (event.target.matches('.product-options input, .product-options select, .sf-product-variant-option-dropdown')) {
      resetQuantity(event.target);
    }
  });
  document.addEventListener('click', (event) => {
    const option = event.target.closest('.product-option-item, .variant-input, .swatch-element');
    if (option) window.setTimeout(() => resetQuantity(option), 80);
  });
  document.querySelectorAll('a[target="_blank"]').forEach((link) => {
    const rel = new Set((link.getAttribute('rel') || '').split(/\s+/).filter(Boolean));
    rel.add('noopener');
    link.setAttribute('rel', [...rel].join(' '));
  });
})();
